export default "__VITE_ASSET__Cj5tPUZt__"